import Akash from '../../assets/icons/akash.svg';
import ArrowDown from '../../assets/icons/arrow/down.svg';
import ArrowLeft from '../../assets/icons/arrow/left.svg';
import ArrowNext from '../../assets/icons/arrow/next.svg';
import ArrowPrevious from '../../assets/icons/arrow/previous.svg';
import ArrowRight from '../../assets/icons/arrow/right.svg';
import ArrowUp from '../../assets/icons/arrow/up.svg';
import Canto from '../../assets/icons/canto.svg';
import Celestia from '../../assets/icons/celestia.svg';
import Check from '../../assets/icons/check.svg';
import Checkmark from '../../assets/icons/checkmark.svg';
import Clock from '../../assets/icons/clock.svg';
import Close from '../../assets/icons/close.svg';
import Copy from '../../assets/icons/copy.svg';
import Cosmos from '../../assets/icons/cosmos.svg';
import Cronos from '../../assets/icons/cronos.svg';
import CryptoCom from '../../assets/icons/cryptoCom.svg';
import CryptoOrg from '../../assets/icons/cryptoOrg.svg';
import Ethereum from '../../assets/icons/ethereum.svg';
import ExternalLink from '../../assets/icons/external-link.svg';
import History from '../../assets/icons/history.svg';
import Info from '../../assets/icons/info.svg';
import Instant from '../../assets/icons/instant.svg';
import Iris from '../../assets/icons/iris.svg';
import Juno from '../../assets/icons/juno.svg';
import Keplr from './Keplr';
import Metamask from '../../assets/icons/metamask.svg';
import Process from '../../assets/icons/process.svg';
import Swap from '../../assets/icons/swap.svg';
import Terra from '../../assets/icons/terra.svg';
import Wallet from '../../assets/icons/wallet.svg';
import Warning from '../../assets/icons/warning.svg';
import WarningTriangle from '../../assets/icons/warning-triangle.svg';
import Network from '../../assets/icons/network.svg';
import Mainnet from '../../assets/icons/mainnet.svg';

const Icon = {
  Akash,
  ArrowDown,
  ArrowLeft,
  ArrowNext,
  ArrowPrevious,
  ArrowRight,
  ArrowUp,
  Canto,
  Celestia,
  Check,
  Checkmark,
  Clock,
  Close,
  Copy,
  Cosmos,
  Cronos,
  CryptoCom,
  CryptoOrg,
  Ethereum,
  ExternalLink,
  History,
  Info,
  Instant,
  Iris,
  Juno,
  Keplr,
  Metamask,
  Process,
  Swap,
  Terra,
  Wallet,
  Warning,
  WarningTriangle,
  Network,
  Mainnet,
};

export default Icon;
